import React from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            <img src="/logo.webp" alt="Dhapu Farms Logo" className="logo-img" />
            <span>Dhapu Farms</span>
          </Link>
        </div>

        <nav>
          <Link to="/">Home</Link>
          <Link to="/products">Products</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact Us</Link>
        </nav>

        <Link to="/contact" className="btn-talk">
          Let's Talk
        </Link>
      </div>
    </header>
  );
}
